<template lang="pug">
    .login-gzzoc
        logo.logo
        user-nav(:show-name="false")
        .content
            login-form.form
            .desc(:class="descClass") {{$t('login.desc')}}
        .footer
            p 备案号: 
                a(href="http://beian.miit.gov.cn", target="_blank") 粤ICP备11021180号-24
        
        //- wave-points.wave-points
</template>

<script>
import Logo from 'components/logo';
import WavePoints from 'components/wave-points';
import LoginForm from '../components/login-form';
import UserNav from 'components/user-nav';
import ls from '@/utils/local-storage';

export default {
    components: {
        Logo,
        LoginForm,
        WavePoints,
        UserNav
    },
    computed: {
        descClass () {
            let cls = ls.get('lang');
            return {
                'en': cls === 'en'
            };
        }
    }
};
</script>

<style lang="sass" scoped>
    .login-gzzoc
        min-height: 100%
    .content
        width: 400px
        z-index: 1
        position: absolute
        top: 45%
        left: 35%
        transform: translate(-50%, -185px)
    .title
        color: rgba(#fff, 0.8)
        font-size: 30px
        line-height: 30px
        margin-bottom: 20px
        font-weight: bold
        width: 426px
    .desc
        margin-top: 24px
        font-family: PingFangSC-Regular
        font-size: 14px
        color: #333333
        letter-spacing: 0.4px
        text-align: justify
        &.en
            font-size: 12px
            line-height: 16px
    .wave-points
        position: absolute
        top: 400px
        left: 0
        right: 0
        height: 500px
    .footer
        width: 100%
        position: absolute
        bottom: 20px
        p
            text-align: center
            color: #4e5876
            a
                color: #4e5876
</style>

